<freud-dialog
	class="export-modal"
	[visible]="isOpen"
	(visibleChange)="!$event && close()"
	[modal]="true"
	[draggable]="false"
	[header]="'EXPORT.MODAL_TITLE' | translate"
>
	<freud-divider></freud-divider>
	<span class="export-modal__description">{{
		'EXPORT.MODAL_DESCRIPTION' | translate
	}}</span>
	<div class="zk-w-2/3 zk-mt-4">
		<label class="zk-mb-2">{{ 'EXPORT.MOTIVE' | translate }}*</label>
		<div class="zk-flex zk-flex-col zk-mb-3">
			<freud-radio-button
				[ngClass]="{ 'radio-invalid': !reason && form.controls.reason.touched }"
				[(ngModel)]="reason"
				[label]="'EXPORT.MOTIVE_1' | translate"
				[name]="'reason'"
				[radioValue]="'physical_storage'"
				inputId="phisical_storage"
			>
			</freud-radio-button>
			<freud-radio-button
				[ngClass]="{ 'radio-invalid': !reason && form.controls.reason.touched }"
				[(ngModel)]="reason"
				[label]="'EXPORT.MOTIVE_2' | translate"
				[name]="'reason'"
				[radioValue]="'platform_migration'"
				inputId="plataform_migration"
			>
			</freud-radio-button>
			<freud-radio-button
				[ngClass]="{ 'radio-invalid': !reason && form.controls.reason.touched }"
				[(ngModel)]="reason"
				[inputId]="1"
				[label]="'EXPORT.MOTIVE_3' | translate"
				[name]="'reason'"
				inputId="required_by_customer"
				[radioValue]="'required_by_customer'"
			>
			</freud-radio-button>
			<freud-radio-button
				[ngClass]="{
					'radio-invalid': !reason && form.controls.reason.touched
				}"
				[(ngModel)]="reason"
				[label]="'EXPORT.MOTIVE_4' | translate"
				[name]="'reason'"
				[radioValue]="'another'"
				inputId="another"
			>
			</freud-radio-button>
			<freud-input-text
				class="zk-mt-3 zk-block"
				*ngIf="reason === 'another'"
				[formControl]="form.controls.anotherReason"
				[label]="'EXPORT.MOTIVE_ANOTHER' | translate"
				[invalid]="
					reason === 'another' &&
					form.controls.anotherReason.touched &&
					form.controls.anotherReason.invalid
				"
				[attr:aria-autocomplete]="false"
				[disabled]="reason !== 'another'"
			></freud-input-text>
		</div>
		<div class="zk-block zk-mb-3 zk-relative">
			<div
				class="export-modal__tooltip"
				freud-tooltip
				[tooltipLabel]="'EXPORT.TOOLTIP_PASSWORD' | translate"
				tooltipPosition="right"
			>
				<span class="freud-icon freud-icon-help"></span>
			</div>

			<freud-input-password
				[formControl]="form.controls.password"
				[invalid]="
					form.controls.password.invalid && form.controls.password.touched
				"
				[label]="('EXPORT.PASSWORD' | translate) + '*'"
				[feedback]="false"
				[placeholder]="'EXPORT.PASSWORD_PLACEHOLDER' | translate"
			></freud-input-password>
		</div>
	</div>

	<freud-checkbox
		[formControl]="form.controls.terms"
		class="zk-mt-5 zk-block"
		[label]="'EXPORT.TERM_CHECKBOX' | translate"
	></freud-checkbox>
	<div
		freudTemplatefooter
		class="zk-flex zk-w-full zk-justify-between zk-align-items"
	>
		<span class="export-modal__required"
			>*{{ 'EXPORT.REQUIRED_FIELD' | translate }}</span
		>
		<freud-button
			[loading]="isLoading"
			[disabled]="!form.controls.terms.value"
			(click)="export(!form.controls.terms.value)"
			>{{ 'EXPORT.BUTTON' | translate }}</freud-button
		>
	</div>
	<freud-divider></freud-divider>
</freud-dialog>
